import Video from './Video';
import VideoCompetitor from './videoCompetitor';

const PgVideos = {
  Video,
  VideoCompetitor
};

export default PgVideos;
